import { KeyValueInterface } from "./interfaces";

export const monthLabels: KeyValueInterface[] = [
  { key: 1, value: "stycznia" },
  { key: 2, value: "lutego" },
  { key: 3, value: "marca" },
  { key: 4, value: "kwietnia" },
  { key: 5, value: "maja" },
  { key: 6, value: "czerwca" },
  { key: 7, value: "lipca" },
  { key: 8, value: "sierpnia" },
  { key: 9, value: "września" },
  { key: 10, value: "października" },
  { key: 11, value: "listopada" },
  { key: 12, value: "grudnia" },
];

export const badgeBackground = ["primary", "secondary", "success", "danger", "warning", "info", "dark"];

export const adminMenuItems = [
  { link: "add_news", descr: "Dodaj newsa" },
  { link: "add_article", descr: "Dodaj artykuł" },
  { link: "edit_news", descr: "Edytuj newsy" },
  { link: "edit_articles", descr: "Edytuj artykuły" },
];
